import { moduleProviderFactory } from "core/providers";
import { FacilityOrderListNewFlow, FacilityOrderNewFlowPreview, FacilityOrderTemplateNewFlowPatientCreate, FacilityOrderNewFlowHistoryList } from "application/facility-order-new-flow/pages";

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: "master.app.main.facility-order",
				pattern: "/facility-orders",
                children: [
					{
						name: "master.app.main.facility-order.facility-order-new-flow.list",
						pattern: "/new-flow",
						tabTitle: 'FACILITY_ORDER.LIST.TITLE',
						component: FacilityOrderListNewFlow,
						authorization: "facilityOrderSection.read",
						data: {
							title: "FACILITY_ORDER.LIST.TITLE",
						},
					},
					{
						name: "master.app.main.facility-order.facility-order-new-flow.preview",
						pattern: "/:id/new-flow",
						authorization: "facilityOrderSection.update",
						component: FacilityOrderNewFlowPreview,
						data: {
							back: "master.app.main.facility-order.facility-order-new-flow.list",
							// title: "Facility Order",
							crumbs: {
								title: "FACILITY_ORDER.CRUMB.TEMPLATES",
								route: 'master.app.main.facility-order.facility-order-new-flow.preview'
							}
						},
					},
					{
						name: "master.app.main.facility-order.facility-order-new-flow.create-patient",
						pattern: "/:id/new-flow/create-patient",
						authorization: "facilityOrderSection.create",
						tabTitle: 'Create New Patient',
						component: FacilityOrderTemplateNewFlowPatientCreate,
						data: {
							crumbs: [
								{
									title: "FACILITY_ORDER.CRUMB.TEMPLATES",
									route: 'master.app.main.facility-order.facility-order-new-flow.preview'
								},
								{
									title: "FACILITY_ORDER.CRUMB.CREATE_NEW_PATIENT",
									route: 'master.app.main.facility-order.facility-order-new-flow.create-patient'
								}
							],
							back: "master.app.main.facility-order.facility-order-new-flow.preview",
						},
					},
					{
						name: "master.app.main.facility-order.facility-order-new-flow.history",
						pattern: "/:id/new-flow/history",
						authorization: "facilityOrderSection.read",
						component: FacilityOrderNewFlowHistoryList,
						data: {
							title: "FACILITY_ORDER.CRUMB.HISTORY",
							crumbs: [
								{
									title: "FACILITY_ORDER.CRUMB.HISTORY",
									route: 'master.app.main.facility-order.facility-order-new-flow.history'
								}
							],
							back: "master.app.main.facility-order.facility-order-new-flow.us-intake-preview",
						},
					}
                ]
            }
        ],
        menu: [
            {
				title: "MENU.FACILITY_ORDERS",
				icon: "package",
				authorization: "coreUserSection.read",
				order: 5,
				subMenu: [
					{
						title: "MENU.FACILITY_ORDERS_SUB",
						authorization: "facilityOrderSection.read",
						route: "master.app.main.facility-order.facility-order-new-flow.list",
						order: 2,
					}
				]
			},
        ]
    });
})();
